import { render, staticRenderFns } from "./CategoryElements.vue?vue&type=template&id=7e835f6d&scoped=true&"
import script from "./CategoryElements.vue?vue&type=script&lang=js&"
export * from "./CategoryElements.vue?vue&type=script&lang=js&"
import style0 from "./CategoryElements.vue?vue&type=style&index=0&id=7e835f6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e835f6d",
  null
  
)

export default component.exports